import React, { useState, useEffect } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import classes from "./AddLocation.module.css";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import CustomMap from "../../../../CustomMap/CustomMap";
import { Row, Col } from "react-bootstrap";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { ImageWithLocationIcon } from "../../../../../constant/imagePath";
import LocationInput from "../../../../../stories/LocationInput/LocationInput";
import Maps from "../../../../Maps";

export default function AddLocationModal({
  show,
  setShow,
  data,
  onAdd,
  isEditing,
}) {
  const [venueName, setVenueName] = useState(data?.venueName);
  const [address, setAddress] = useState(data?.address);
  const [isMobile, setIsMobile] = useState(false);
  const [coordinate, setCoordinate] = useState({});
  const [locationDetail, setLocationDetail] = useState({});

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);

  function addLocation() {
    console.log("run");
    let newData = {
      _id: isEditing ? data?._id : Math.floor(Math.random() * 10000),
      venueName: venueName,
      address: address,
      img: ImageWithLocationIcon,
      city: locationDetail?.city,
      state: locationDetail?.state,
      country: locationDetail?.country,
    };
    console.log({ newData });
    console.log("onAdd", onAdd);
    onAdd(newData);
    setShow(false);
  }
  return (
    <>
      <style>{`

          @media screen and (max-width:768px){
          .modal .modal-dialog {
            max-width: 80%;
            margin: 0px auto;
                             }
            .${classes.mapBox}{
              height:120px;
            }

          }
    `}</style>

      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"20px"}
        width={"570px"}
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        header={
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            {isMobile ? "Add a place" : "Add Location"}
          </h4>
        }
        footer={
          isMobile && (
            <div className={classes.footerBtns}>
              <LinkButtonWithIcon
                text={"Cancel"}
                textColor={Colors.neutralShadesOfNero}
              />
              <Button
                label={"Add"}
                primary={true}
                size={"Medium"}
                customStyle={{
                  width: "max-content",
                  height: "48px",
                  marginLeft: "48px",
                }}
                onClick={() => addLocation()}
              />
            </div>
          )
        }
      >
        <div className={classes.modalContent}>
          {/* Map */}
          <div className={`${[classes.mapBox, classes.mb24].join(" ")}`}>
            <CustomMap myCoords={coordinate} borderRadius={"20px"} />
          </div>
          {/* Venue Name */}
          <div className={classes.mb24}>
            <Input
              state={venueName}
              label={"Venue Name (Optional)"}
              placeholder="Type address"
              setter={setVenueName}
            />
          </div>
          <div className={classes.mb24}>
            <Maps
              type={"places"}
              label={"Address"}
              setAddress={setAddress}
              placeholder={"Type here.."}
              setCoordinates={setCoordinate}
              setPlaceDetail={setLocationDetail}
            />
          </div>

          {/* <Row>
            <Col md={isMobile ? 12 : 4} sm={12} className={classes.mb24}>
              <Input
                label={"City"}
                state={data?.city ? data?.city : locationDetail?.city}
                disabled={true}
              />
            </Col>
            <Col md={isMobile ? 12 : 4} sm={12} className={classes.mb24}>
              <Input
                label={"State"}
                state={data?.state ? data?.state : locationDetail?.state}
                disabled={true}
              />
            </Col>
            <Col md={isMobile ? 6 : 4} sm={4} xs={6}>
              <Input
                label={"Country"}
                state={data?.country ? data?.country : locationDetail?.country}
                disabled={true}
              />
            </Col>
          </Row> */}

          {!isMobile && (
            <div className={`${[classes.btnBox, classes.mt24].join(" ")}`}>
              <Button
                label={"Add a place"}
                primary={true}
                size={"Large"}
                onClick={() => addLocation()}
              />
            </div>
          )}
        </div>
      </ModalSkeleton>
    </>
  );
}
